export abstract class  DataDelegate {
    private _name: string;
    public get Name() {
        return this._name;
    }

    private _data: any = [];
    public get Data() {
        return this._data;
    }
    public set Data(data: any) {
        this._data = data;
    }

    constructor(name: string) {
        this._name = name;
    }

    public clearData() {
        this._data = [];
    }
}
